<template>
  <fts-dropdown-select
    append-to-body
    class="fts-standard-menu"
    @selected="executeActivity"
    v-if="isStandardAction">
    <!-- toggle -->
    <template #toggle>
      <slot name="toggle">
        <font-awesome-icon
          :icon="['fas', 'ellipsis-v']"
          fixed-width
          class="standard-menu-toggle"
        />
      </slot>
    </template>
    <!-- menu -->
    <template #menu="{ select, defaultOptionClass }">
      <!-- view -->
      <a
        class="standard-activity"
        :class="defaultOptionClass"
        :href="locusUrl"
        target="_blank"
        @click="select"
        v-if="getStandardAction('view')"
      >
        <i class="standard-activity-icon" :class="icon('view')" />View in New Window
      </a>
      <!-- edit -->
      <div
        class="standard-activity"
        :class="defaultOptionClass"
        @click="select({ id: 'edit' })"
        v-if="getStandardAction('edit')"
      >
        <i class="standard-activity-icon" :class="icon('edit')" />Edit
      </div>
      <!-- delete -->
      <div
        class="standard-activity"
        :class="defaultOptionClass"
        @click="select({ id: 'delete' })"
        v-if="getStandardAction('delete')"
      >
        <i class="standard-activity-icon" :class="icon('delete')" />Delete
      </div>
      <!-- change state -->
      <div
        class="standard-activity"
        :class="defaultOptionClass"
        @click="select({ id: 'changeStatus' })"
        v-if="getStandardAction('changeStatus')"
      >
        <i class="standard-activity-icon" :class="icon('changeStatus')" />Change State
      </div>
      <!-- duplicate -->
      <div
        class="standard-activity"
        :class="defaultOptionClass"
        @click="select({ id: 'duplicate' })"
        v-if="getStandardAction('duplicate')"
      >
        <i class="standard-activity-icon" :class="icon('duplicate')" />Duplicate
      </div>
    </template>
  </fts-dropdown-select>
</template>

<script>
import commons from "../commons/commons";

import FTSDropdownSelect from "./FTSDropdownSelect";

export default {
  components: {
    "fts-dropdown-select": FTSDropdownSelect,
  },
  props: {
    standardActions: {
      type: Array,
      default: () => [],
    },
    item: {
      type: Object,
      default: () => ({}),
    },
    moduleId: [String, Number],
    listId: String,
  },
  methods: {
    icon(id) {
      try {
        return commons.standardActivities.find((x) => x.id === id).icon;
      } catch (err) {
        return "fts-icon-file";
      }
    },
    getStandardAction(item) {
      return this.standardActions.some((x) => x === item);
    },
    executeActivity(item) {
      if (item && item.id)
        this.$emit("executed", item);
    },
  },
  computed: {
    isStandardAction() {
      return this.standardActions.some(
        x => ['view', 'edit', 'delete', 'changeStatus', 'duplicate'].indexOf(x) > -1
      );
    },
    locusUrl() {
      return commons.clientPathUrl({
        moduleId: this.moduleId,
        listId: this.listId,
        id: this.item.id,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./src/assets/scss/vars.scss";

.fts-standard-menu {
  .standard-menu-toggle {
    font-size: 0.75rem;
    color: var(--fts-gray-5);
  }
  .standard-activity {
    font-size: .875rem;
    .standard-activity-icon {
      margin-right: .575rem;
      color: var(--fts-gray-5);
    }
  }
}
</style>